import fetchData from "./fetchData";

export default function getSearchUrl() {
	return (dispatch) => {
		/**
		 * Check URL params.
		 * Als je benamingen aanpast -> ook in fetchData() functie aanpassen.
		 */
		var url = window.location.search;
		var query = new URLSearchParams(url);
		let pagina = query.get("pagina") ? query.get("pagina") : "";
		let string = query.get("q") ? query.get("q") : "";

		// @todo: bij initialiseren queryvalue invullen (maar toont dan geen X)
		document.querySelector(".queryValue").value = string;

		let regions = query.get("regions") ? query.get("regions") : "";
		let subjects = query.get("vakken") ? query.get("vakken") : "";
		let location = {};

		/**
		 * Location check en samenvoegen parameters om zoek naar Solr te kunnen doen.
		 * Er dient een ',' aanwezig te zijn om te checken op een geldige lat & lng.
		 */
		if (
			query.get("idb") &&
			query.get("idb_geo") &&
			query.get("idb_geo").includes(",")
		) {
			let locationArr = query.get("idb_geo").split(",");

			location["city"] = query.get("idb");
			location["lat"] = locationArr[0];
			location["lng"] = locationArr[1];

			/**
			 * Location value dient gezet te worden via vanilla JS.
			 * Anders zijn er problemen met de Google Maps event handler.
			 */
			document.querySelector(".locationValue").value = location["city"];
		} else {
			document.querySelector(".locationValue").value = "";
		}

		/**
		 * CATEGORIEËN PARSEN
		 * Topthema & thema samenvoegen om zo de zoekquery correct te kunnen uitvoeren (zoekparameter = topthema|thema).
		 * Categories worden in een state gezet eerst omdat categorieën eerst
		 * ingeladen dienen te worden alvorens je daar een label uit kan halen.
		 * Pas daarna wordt in componentDidUpdate het event gedispatcht
		 * om de actieve categorie uit de URL te zetten.
		 */
		let categories = "";
		let topthema = query.get("topthema") ? query.get("topthema") : "";
		let thema = query.get("thema") ? query.get("thema") : "";

		if ("" !== thema) {
			categories = topthema + "|" + thema;
		} else {
			categories = topthema;
		}

		dispatch(fetchData(pagina, string, categories, regions, subjects, location));
	};
}
